import { SEARCH_TYPE } from './../../../services/search/search.service';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from './../../../services/storage/storage.service';
import { RoutingService } from './../../../services/routing/routing.service';
import { BrowseTerm } from '../browse.component';
import { SearchService } from '../../../services/search/search.service';
import { SharedService } from '../../../services/shared/shared.service';
import { SearchRequestPayload } from '../../../core/interfaces/search.interface';
import { AnalyticsService } from '../../../services/analytics/analytics.service';

@Component({
  selector: 'ag-browse-table',
  templateUrl: './browse-table.component.html',
  styleUrls: ['./browse-table.component.scss'],
})
export class BrowseTableComponent {
  @Input() browseTerms: BrowseTerm[];

  constructor(
    private _router: Router,
    private _routingService: RoutingService,
    private _searchService: SearchService,
    private _sharedService: SharedService,
    private _storageService: StorageService,
    private _analyticsService: AnalyticsService,
  ) {}

  search(data: BrowseTerm) {
    const searchRequestPayload: SearchRequestPayload = {
      searchQuery: {
        limitToQueryOnly: true,
        facetMatches: [],
        facetOffset: 0,
        filters: { scopingLevel: 0 },
        matches: [
          {
            index: data.index,
            query: data.term,
            queryOption: 'STARTS',
            matchJoinOperator: 'AND',
          },
        ],
        numOfFacetPerGroup: 0,
        numOfRecords: 40,
        orderBy: 'asc',
        resources: [data.resource],
        resultType: 'none',
        searchType: SEARCH_TYPE.BROWSE,
        sortBy: ['relevance'],
        startRecord: 1,
        isKidsSearch: this._sharedService.getIsKidsCat(),
      },
    };

    if (data.hitCount > 1) {
      this._searchService.doSearch(searchRequestPayload);
    } else {
      this._searchService.performSearchAndWait(searchRequestPayload).subscribe(
        (response) => {
          const record = response.results[0];
          const doc = record.formats[0].documents[0];
          this._analyticsService.logEvent('View Details');
          this._routingService.pushOnBackStack();
          this._routingService.goToFullRecord(
            doc.agControlId,
            doc.shard,
            null,
            doc.isRefdb,
            doc.refdbFullRecUrl,
          );
        },
        (error: unknown) => {
          console.error(`Error in BrowseTableComponent: ${JSON.stringify(error)}`);
          this._sharedService.unableToCompleteRequestMessage();
        },
      );
    }
  }
}
